// extracted by mini-css-extract-plugin
export default {"modal":"FeedModal_modal__jyTZW"};